export default __webpack_public_path__ + "static/media/encoding_decoding_scheme.27cf93f3.png";